import { ExternalLink } from 'lucide-react';
import { Trail } from '../../lib/types';

interface TrailCardProps {
  trail: Trail;
}

export function TrailCard({ trail }: TrailCardProps) {
  const getDifficultyColor = (difficulty: Trail['difficulty']) => {
    switch (difficulty) {
      case 'green': return 'bg-green-500';
      case 'blue': return 'bg-blue-500';
      case 'red': return 'bg-red-500';
      case 'black': return 'bg-black';
      default: return 'bg-gray-500';
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className={`w-4 h-4 rounded-full ${getDifficultyColor(trail.difficulty)}`} />
        <h3 className="text-xl font-semibold">{trail.name}</h3>
      </div>
      <div className="space-y-2 text-gray-600">
        <p>Lungime: {trail.length}</p>
        <p>Diferență de nivel: {trail.altitudeDescent}</p>
      </div>
      <a
        href={trail.trailforksLink}
        target="_blank"
        rel="noopener noreferrer"
        className="text-orange-500 hover:text-orange-600 flex items-center gap-1 mt-4"
      >
        Vezi pe Trailforks
        <ExternalLink className="w-4 h-4" />
      </a>
    </div>
  );
}